<template>
  <div class="media-card-wrapper" v-if="visible" @click="onClick">
    <slot></slot>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * The
     */
    visible: {
      default: false,
    },
  },
  emits: ["close"],
  setup(props, { emit }) {
    const onClick = () => {
      emit("close");
    };

    return { onClick };
  },
};
</script>

<style>
.media-card-wrapper {
  background: rgba(0, 0, 0, 0.7);
  width: 100%;
  height: 100%;
  position: fixed;
  left: 0;
  top: 0;
  overflow: auto;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
